@if (initialized) {

  @if (selectedType?.scheduleTypeInternal != ScheduleTypeInternal.whatsapp &&
  selectedType?.scheduleTypeInternal != ScheduleTypeInternal.bookings &&
  selectedType?.scheduleTypeInternal != ScheduleTypeInternal.call_us &&
  selectedType?.scheduleTypeInternal != ScheduleTypeInternal.vcard_qr) {


    <ul class="list-none px-0 pb-0 pt-4 m-0 border-top-1 surface-border">
      @for (type of scheduleTypes; track type.id) {
        <li class="py-2" (click)="handleScheduleTypeSelect(type)">
          <label [for]="type.uiLabel"
                 class="cursor-pointer flex align-items-center border-round border-transparent p-3 transition-colors transition-duration-150"
                 [ngClass]="selectedScheduleType == type.uiLabel ? 'border-3 border-blue-300' : 'border-1 hover:border-300'">
                    <span
                      [ngClass]="type.scheduleTypeInternal | dynamicClassPipe"
                      class="inline-flex align-items-center justify-content-center border-round flex-shrink-0"
                      style="height:45px;width:45px;">
                      <div [innerHTML]="type.scheduleTypeInternal | iconDisplay"></div>
                    </span>
            <div class="ml-3">
              <span class="text-color text-xl font-medium">{{ type.uiLabel }}</span>
              <p class="text-color-secondary text-base m-0">{{ type.uiMessage }}</p>
            </div>
            @if (type.scheduleTypeInternal != ScheduleTypeInternal.call_me_back && type.scheduleTypeInternal != ScheduleTypeInternal.none) {
              <i class="text-600 pi pi-chevron-right ml-auto"></i>
            } @else {
              <p-radioButton [name]="type.uiLabel" [value]="type.uiLabel" [inputId]="type.uiLabel"
                             [(ngModel)]="selectedScheduleType" class="ml-auto"></p-radioButton>
            }
          </label>
        </li>
      }
    </ul>

  } @else {
    @if (selectedType?.scheduleTypeInternal == ScheduleTypeInternal.whatsapp) {
      <schedule-appointment-whatsapp></schedule-appointment-whatsapp>
    } @else if (selectedType && selectedType.scheduleTypeInternal == ScheduleTypeInternal.bookings) {
      <schedule-appointment-booking
        [scheduleTypeId]="selectedType.id"
        [appointmentTypeId]="appointmentTypeId"
        (onSelectPeriod)="handleSelectPeriodBooking($event)"
      ></schedule-appointment-booking>
    } @else if (selectedType?.scheduleTypeInternal == ScheduleTypeInternal.call_us) {
      <schedule-appointment-call-us></schedule-appointment-call-us>
    } @else if (selectedType?.scheduleTypeInternal == ScheduleTypeInternal.vcard_qr) {
      <v-card [scheduleType]="selectedType"></v-card>
    }

    @if (showPreviousButton) {
      <hr class="mt-8">
      <app-button [busy]="busy"
                  [disabled]="busy"
                  [label]="'Zurück'"
                  [iconPos]="'left'"
                  [showIcon]="true"
                  [icon]="'pi pi-arrow-left'"
                  (onClick)="handlePreviousStep()">
      </app-button>
    }


  }
}
